<template>
  <div @mouseenter="onMouseEnter" @mouseleave="onMouseLeave" v-click-outside="closeSubMenu">
    <v-navigation-drawer clipped app permanent light color="#FFFFFF" :width="300" :mini-variant-width="80"
      :mini-variant="$store.state.Drawer" style="cursor: pointer;">
      <div @click="onClickLogo">
        <v-list style="margin-bottom: 10px;">
          <v-list-item>
            <router-link to="/" exact>
              <v-img src="@/assets/logo.png" alt="" width="50px" height="50px" contain />
            </router-link>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
      </div>

      <div class="scrollable-list">
        <v-list>
          <v-list-item-group mandatory v-model="$store.state.modelmenu">
            <v-menu v-for="item in menus" :key="item.title" v-model="item.active" :prepend-icon="item.action" bottom
              offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item v-on="on" v-bind="attrs" @click="onClickMenuItem(item, `mainmenu`)"
                  style="margin-bottom: -10px;">
                  <v-list-item-icon>
                    <v-icon v-text="item.action" :style="{
                      paddingLeft: $store.state.Drawer ? '0px' : '5px',
                    }"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon v-if="!item.route">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </template>
              <div class="scrollable-submenu">
                <v-list v-if="!item.route">
                  <v-list-item-content color="#e4e8ff" class="tile" v-for="subItem in item.items" :key="subItem.title"
                    @click="onClickMenuItem(subItem, `submenu`)">
                    <v-list-item-title class="ml-3">{{
                      subItem.title
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list>
              </div>
            </v-menu>
          </v-list-item-group>
        </v-list>
      </div>
      <v-divider></v-divider>
      <div align="start" justify="start" style="padding: 10px 0px 0px 10px; font-size: 10px; font-weight: 500;"
        @click="onClickLogo">
        Versions {{ version }}
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import api from "../../services/api";
import { server } from "../../services/constants";

export default {
  data() {
    return {
      isBeForMenu: "",
      isDoubleClicked: false,
      isClicked: false,
      // ⭐ เดิมเป็น array เมนู hardcode ทั้งหมด (~700 บรรทัด)
      // ตอนนี้ดึงจาก backend ผ่าน api.getMenuTree() แทน ดู loadMenus()
      menus: [],
      selectedMenu: null,
    };
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
    },
  },
  watch: {
    $route(to, from) {
      this.selectedMenu = this.menus.findIndex(
        (menu) => menu.items.findIndex((item) => item.route == to.path) != -1,
      );
    },
  },
  async mounted() {
    try {
      this.$store.state.modelmenu = parseInt(
        localStorage.getItem(server.MODELMENU),
      );

      await this.loadMenus();
    } catch (error) {
      console.error("Menu.vue mounted error:", error);
    }
  },
  methods: {
    /**
     * ⭐ ใหม่: ดึงเมนู (group + submenu) จาก backend ตามสิทธิ์ของ user ที่ login
     * แทนการ fix ค่าใน data() -> menus: []
     * ใช้ AUTHORIZE_ID (= setting_group_menu_id ที่ผูกไว้ตอน login) + COMPANYID
     */
    async loadMenus() {
      try {
        const setting_group_menu_id = localStorage.getItem(server.AUTHORIZE_ID);
        const company_id = localStorage.getItem(server.COMPANYID);

        if (!setting_group_menu_id || !company_id) {
          console.warn(
            "Menu.vue: ไม่พบ AUTHORIZE_ID หรือ COMPANYID ใน localStorage กรุณา login ใหม่",
          );
          this.menus = [];
          return;
        }

        const res = await api.getMenuTree(setting_group_menu_id, company_id);
        this.menus = (res.data && res.data.menus) || [];
      } catch (error) {
        console.error("Menu.vue loadMenus error:", error);
        this.menus = [];
      }
    },

    onMouseEnter() {
      if (!this.isClicked) {
        this.isDoubleClicked = false;
        this.$store.state.Drawer = false;
      }
    },
    onMouseLeave() {
      if (!this.isClicked) {
        this.$store.state.Drawer = true;
      }
    },

    onClickMenuItem(link, mode) {
      this.isClicked = true;
      localStorage.setItem(server.MODELMENU, link.index);

      this.$router.push(link.route).catch((err) => { });

      if (mode == `mainmenu`) {
        if (link.items.length == 0) {
          setTimeout(() => {
            this.isClicked = false;
          }, 50);
        } else {
          if (this.isBeForMenu == link.title) {
            this.isDoubleClicked = !this.isDoubleClicked;
          } else {
            this.isDoubleClicked = true;
            this.isBeForMenu = link.title;
          }

          if (!this.isDoubleClicked) {
            setTimeout(() => {
              this.isClicked = false;
            }, 50);
          }
        }
      } else {
        this.isDoubleClicked = !this.isDoubleClicked;
        this.isClicked = false;
        this.$store.state.Drawer = true;
      }
    },

    onClickLogo() {
      this.isDoubleClicked = false;
      this.isClicked = true; // ตั้งค่า isClicked เป็น true เมื่อคลิกโลโก้
      this.$store.state.Drawer = true; // ตั้งค่า Drawer เป็น true

      setTimeout(() => {
        this.isClicked = false; // คืนค่าเป็น false หลังจากเวลาที่กำหนด
      }, 500); // หน่วงเวลา 500ms หลังจากคลิก
    },
    closeSubMenu() {
      this.$store.state.Drawer = true;
      setTimeout(() => {
        this.isClicked = false; // คืนค่าเป็น false หลังจากเวลาที่กำหนด
      }, 50);
    },
  },
};
</script>

<style scoped>
.v-list-item-group .v-list-item {
  transition: background-color 0.3s ease;
}

.v-list-item-group .v-list-item:hover {
  background-color: #daf2fa;
  /* สีที่ต้องการเมื่อ hover */
}

.v-list-item-group .v-list-item-icon v-icon {
  transition: color 0.3s ease;
}

.v-list-item-group .v-list-item:hover v-icon {
  color: #0a7ea5;
  /* สีที่ต้องการเปลี่ยนเมื่อ hover ไอคอน */
}

.v-list-item-group .v-list-item--active {
  color: #4169e1;
}

.theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  opacity: 0.7;
}

.tile {
  cursor: pointer;
  margin: 5px;
  border-radius: 4px;
}

.tile:hover {
  color: white;
  background-color: #4169e1;
}

.tile:active {
  background: #4169e1;
}

.scrollable-list {
  height: 84%;
  overflow-y: hidden;
  transition: overflow-y 0.3s;
}

.scrollable-list:hover {
  overflow-y: auto;
  padding-right: 4px;
}

.scrollable-list::-webkit-scrollbar {
  width: 4px;
}

.scrollable-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.scrollable-list::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.scrollable-list::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.scrollable-submenu {
  max-height: 520px;
  overflow-y: hidden;
  transition: overflow-y 0.3s;
}

.scrollable-submenu:hover {
  overflow-y: auto;
}

.scrollable-submenu::-webkit-scrollbar {
  width: 4px;
}

.scrollable-submenu::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.scrollable-submenu::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.scrollable-submenu::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
